import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Chip, Text } from 'react-native-paper';
import { ITimelineItem } from '../features/immersive-news-article/types';
import { useThemeSettings } from '../ThemeProvider';
import { CustomIcon } from './CustomIcon';

interface TimelineContentProps {
  timelineData: ITimelineItem[];
  style?: object;
}

export const TimelineContent: React.FC<TimelineContentProps> = ({ timelineData, style = {} }) => {
  const { theme, isDark } = useThemeSettings();
  return (
    <View>
      {timelineData.map((item, index) => (
        <View key={index} style={styles.timelineItem}>
          <Chip
            mode="flat"
            style={{ borderRadius: 16, alignSelf: 'flex-start', backgroundColor: theme?.colors?.btnBgFill, elevation: 2 }}
            textStyle={[theme.fonts.bodySmall, {
              color: theme?.colors?.primary,
            }]}
          >
            {item.date}
          </Chip>
          <Text style={[{ color: theme?.colors?.bodyText, lineHeight: 22.4 }]} variant="bodyMedium">{item.content}</Text>
          {index < timelineData.length - 1 && (
            <CustomIcon icon={isDark ? 'line-dark' : 'line'} size={40} />
          )}
        </View>
      ))}

    </View>
  );
};

const styles = StyleSheet.create({
  timelineItem: {
    flexDirection: 'column',
    gap: 8,
  },
});

export default TimelineContent;
